import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
